import { searchClient, locale } from './algolia-config.js';

const { connectAutocomplete } = instantsearch.connectors;

const AUTOCONNECT_THROTTLE_DELAY = 500;

let autocompleteTimerId;
let lastQuery = '';

const search_predictive = instantsearch({
  indexName: 'shopify_products_predictive_search',
  searchClient
});

const renderAutocomplete = async (renderOptions, isFirstRender) => {
  const { indices, currentRefinement, refine, widgetParams } = renderOptions;
  const { containerSelector, inputSelector, resultsSelector, suggestionsSelector, suggestionsWrapperSelector } = widgetParams;
  const input = document.querySelector(inputSelector);

  if (isFirstRender) {
    input.value = currentRefinement;

    input.addEventListener('input', () => {
      const container = document.querySelector(containerSelector);
      const submitButton = document.querySelector('#submit-link-button-predictive-search');
      const hasValue = input.value.length > 0;

      hasValue ? container.setAttribute('open', '') : container.removeAttribute('open');
      hasValue ? submitButton.closest('button').classList.remove('hidden') : submitButton.closest('button').classList.add('hidden');
      submitButton.innerHTML = submitButton.getAttribute('data-text').replace('%query%', input.value);

      clearTimeout(autocompleteTimerId);
      autocompleteTimerId = setTimeout(() => {
        refine(input.value);
      }, AUTOCONNECT_THROTTLE_DELAY);
    });

    input.addEventListener('focus', () => {
      if (input.value.length > 0) {
        document.querySelector(containerSelector).setAttribute('open', '');
      }
    });

    document.addEventListener('click', (event) => {
      const predictiveSearch = document.querySelector('predictive-search');
      if (!predictiveSearch) return;
      if (!predictiveSearch.contains(event.target)) {
        predictiveSearch.removeAttribute('open');
      }
    });
  }

  if (currentRefinement.length > 0 && indices.some((index) => index.hits.length > 0) && lastQuery === currentRefinement) {
    document.querySelector(resultsSelector).innerHTML = renderIndexResults(indices);
    document.querySelector(suggestionsSelector).innerHTML = await renderSuggestionsResults(currentRefinement, suggestionsWrapperSelector);
    fetchShopifyPredictiveSearchProductCard();
    return;
  }

  if (currentRefinement.length > 0 && indices.some((index) => index.hits.length > 0) && lastQuery !== currentRefinement) {
    lastQuery = currentRefinement;
  }
};

const customAutocomplete = connectAutocomplete(renderAutocomplete);

search_predictive.addWidgets([
  customAutocomplete({
    containerSelector: 'predictive-search',
    inputSelector: '#algolia-header-input',
    resultsSelector: '#predictive-search-results-products-list',
    suggestionsSelector: '#algolia-suggestions-container',
    suggestionsWrapperSelector: '#predictive-search-results-products-list-wrapper',
    mainIndexName: 'shopify_products_predictive_search'
  })
]);

const renderIndexResults = (indices) => {
  return indices
    .map((index) => {
      const { hits } = index;

      return hits
        .map((hit) => {
          return `
            <li
              class="predictive-search__list-item predictive-search__list-item--product"
              role="option"
              aria-selected="false"
            >
              <div
                class="algolia-predictive-search-placeholder"
                data-product-handle="${hit.handle}"
                data-variant-id="${hit.objectID}"
              >
                <div class="loading-placeholder">
                  <div class="loading-spinner"></div>
                </div>
              </div>
            </li>
          `;
        })
        .join('');
    })
    .join('');
};

const renderSuggestionsResults = async (searchValue, suggestionsWrapperSelector) => {
  const wrapper = document.querySelector(suggestionsWrapperSelector);
  wrapper.classList.add('hidden');

  if (searchValue === '') return '';

  const response = await fetch(`${locale != 'de' ? `/${locale}` : ''}/search/suggest.json?q=${searchValue}&section_id=algolia-predictive-search`);
  const jsonResponse = await response.json();

  if (jsonResponse.resources.results.collections.length > 0) {
    wrapper.classList.remove('hidden');

    return jsonResponse.resources.results.collections
      .map((queryHit) => {
        return `
          <li
            class="predictive-search__list-item"
            role="option"
            aria-selected="false"
          >
            <a href="${queryHit.url}" class="predictive-search__item link link--text">
              <div class="predictive-search__item-content predictive-search__item-content--centered">
                <p
                  class="predictive-search__item-heading predictive-search__item-query-result h5"
                  aria-label="${queryHit.handle}"
                >
                  ${queryHit.title}
                </p>
              </div>
            </a>
          <li>
        `;
      })
      .join('');
  }

  return '';
};

const fetchShopifyPredictiveSearchProductCard = () => {
  const placeholderList = document.querySelectorAll('.algolia-predictive-search-placeholder:not(.loaded):not(.fetching)');

  placeholderList.forEach(async (item) => {
    const handle = item.getAttribute('data-product-handle');
    const variantID = item.getAttribute('data-variant-id');

    if (!handle || !variantID) return;

    item.classList.add('fetching');

    try {
      const response = await fetch(`${locale != 'de' ? `/${locale}` : ''}/products/${handle}?variant=${variantID}&view=predictivesearch`);

      if (!response.ok) throw new Error('Product not found');

      const html = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const productCard = tempDiv.querySelector('.card-wrapper');

      if (productCard) {
        item.innerHTML = productCard.outerHTML;
      } else {
        item.innerHTML = html;
      }

      item.classList.add('loaded');
      item.classList.remove('fetching');
    } catch (error) {
      console.error(`Error fetching product card for ${handle}:`, error);
      item.classList.remove('fetching');
    }
  });
};

const initEventListeners = () => {
  const searchButton = document.querySelector('button.header__icon--search');
  const header = document.querySelector('header.header');

  searchButton.addEventListener('click', () => {
    header.classList.toggle('header--mobile-search-hidden');
  });
};

initEventListeners();
search_predictive.start();
